export default function Problem() {
  const problems = [
    {
      icon: 'ri-team-line',
      title: '社内の知識・ノウハウが属人化し、退職で業務が止まるリスクがある',
      description: 'ベテランの経験・知識が個人に依存し、退職や異動で業務が止まるリスクがある。'
    },
    {
      icon: 'ri-search-line',
      title: '設備マニュアル・品質規格などの文書の検索に時間がかかる',
      description: '設備マニュアルや品質規格が膨大で、必要な情報を探すだけで時間を消耗している。'
    },
    {
      icon: 'ri-settings-3-line',
      title: '設備制御・加工プログラムの作成に時間がかかり過ぎる',
      description: 'PLCプログラムやNCコードの作成に時間がかかる。特定の担当者に開発を依存している。'
    },
    {
      icon: 'ri-file-text-line',
      title: '紙・手作業の業務が多くて時間が掛かる',
      description: '日報・帳票・作業記録が紙ベースのまま。入力・集計に時間がかかり、データを活用できていない。'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'データはあるのに活かせていない',
      description: '生産・品質データは記録されているが、集計・分析に時間がかかり、現場の改善に繋げられていない。'
    },
    {
      icon: 'ri-microscope-line',
      title: '品質不良の原因が特定できず、再発を繰り返している',
      description: '不良が出るたびに対策を打つが、根本原因が分からないまま同じ問題が繰り返し発生している。'
    }
  ];

  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#4A5568] text-xs font-bold tracking-widest uppercase mb-4">PROBLEM</p>
          <h2 className="text-4xl font-black text-[#1A3A5C]">
            製造業のAI活用、<br />こんな課題はありませんか？
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 bg-[#E8EDF5] rounded-full flex items-center justify-center mb-6">
                <i className={`${problem.icon} text-3xl text-[#1A3A5C]`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#1A3A5C] mb-4">{problem.title}</h3>
              <p className="text-[#4A5568] text-sm leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <p className="text-xl font-bold text-[#1A3A5C]">
            これらの課題、<span className="text-[#2563EB]">製造業×AI開発を専門とするエンジニア</span>が解決します。
          </p>
        </div>
      </div>
    </section>
  );
}
